import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { IconButton } from '@mui/material';
import { RxReset } from "react-icons/rx";
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from "@mui/material/Checkbox";
import TextField from '@mui/material/TextField';
import constants from '../../../../config/constants';
import { request } from '../../../../_network/request';
import { billingServiceURLs } from '../../../../_network/apiUrls';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import CustomDialog from '../../../_common/CustomDialog';
import CustomSelectField from '../../../_common/_form_fields/CustomSelectField';
import FormControlLabel from '@mui/material/FormControlLabel';
import { openStackServiceLabels, openStackResourceLabels, openStackServices } from '../../../../config/openStackConstants';
import billingTexts from '../../../../texts/billingTexts';

// const drawerWidth = Constants.drawerWidth;

const BillingNewResources = (props) => {
	const { billingServices, existedResources, regions, newResources, handleDataFetch } = props

	// const drawerOpen = useSelector(state => state.drawer.drawerOpened);
	const defaultTexts = billingTexts
	// const clientID = useSelector(state => state.profile.clientAccountID)
	const [selectedResources, setSelectedResources] = useState([])
	const [resourceAddMode, setResourceAddMode] = useState(false)
	// const purchasedService = useSelector(state => state.openstack.purchasedServicesAll)
	const [billingServicesChecked, setBillingServicesChecked] = useState(false)
	// const [priceCreateAllowed, setPriceCreateAllowed] = useState(false)
	const [newResourceCreateDialogOpen, setNewResourceCreateDialogOpen] = useState(false)
	
	const [selectedDefaultResources, setSelectedDefaultResources] = useState([])
	const [newDefaultResources, setNewDefaultResources] = useState([])

	const [newBackupResource, setNewBackupResource] = useState(false)
	const [newSnapshotResource, setNewSnapshotResource] = useState(false)
	const [newRouterResource, setNewRouterResource] = useState(false)
	const [newIPResource, setNewIPResource] = useState(false)
	const [newImageResource, setNewImageResource] = useState(false)
	const [newZoneResource, setNewZoneResource] = useState(false)
	const [newLoadbalancerResource, setNewLoadbalancerResource] = useState(false)

	const [selectedFWResources, setSelectedFWResources] = useState([])
	const [newFWResources, setNewFWResources] = useState([])
	const [newFWResource, setNewFWResource] = useState(false)
	const [duplicatedFWResources, setDuplicatedFWResources] = useState(false)

	const [selectedVPNResources, setSelectedVPNResources] = useState([])
	const [newVPNResources, setNewVPNResources] = useState([])	
	const [duplicatedVPNResources, setDuplicatedVPNResources] = useState(false)
	const [newIKEResource, setNewIKEResource] = useState(false)
	const [newIPSecResource, setNewIPSecResource] = useState(false)

	const account_id = useSelector(state => state.profile.account_id)
	const user_role = useSelector(state => state.profile.user_role)
  const editPermission = user_role === 'superadmin' || user_role === 'owner' || user_role === 'admin'

	const clientID = account_id

	const theme = useTheme()

	const algorithm_list = [
		{
			value: '3des',
			keyword: '3des',
		},
		{
			value: 'aes-128',
			keyword: 'aes-128',
		},
		{
			value: 'aes-192',
			keyword: 'aes-192',
		},
		{
			value: 'aes-256',
			keyword: 'aes-256',
		},
	]

	const isResourcePriceSet = (resource_name) => {
		let result = true

		regions.forEach(reg => {
			const existed_resource = existedResources.find(item => item.region_name === reg.value && item.resource_name === resource_name)

			if (!existed_resource) {
				result = false
			}
		})

		return result
	}

	const getFilteredRegionList = (resource_name) => {
		let result = []

		regions.forEach(reg => {
			const existed_resource = existedResources.find(item => item.region_name === reg.value && item.resource_name === resource_name)

			if (!existed_resource) {
				result.push(reg)
			}
		})

		return result
	}

	const handleSelectNewResourceEditing = (event, resource) => {
			if (event.target.checked) {
					let new_item = {}
					new_item["account_id"] = clientID
					new_item["region_name"] = resource.region_name
					new_item["service_name"] = resource.service_name
					new_item["resource_name"] = resource.resource_name
					new_item["resource_id"] = resource.id
					if (resource.resource_name === "instance") {
							new_item["price"] = {"active": 0.0, "other": 0.0}
							new_item["props"] = {
									name: resource.name, 
									cpu: resource.vcpus, 
									ram: resource.ram, 
									disk: resource.disk
							}
					} else {
							new_item["price"] = 0.0
							new_item["props"] = {name: resource.name}
					}
					let new_list = [...selectedResources, new_item]
					setSelectedResources(new_list)
			} else {
					let new_list = selectedResources.filter(
							res => res.resource_id !== resource.id)
							setSelectedResources(new_list)
			}
	}

	const handlePriceChange = (event, item_id, status) => {
			const new_list = selectedResources.map(item => {
					if (item.resource_id === item_id) {
							let new_item = {...item}
							if (item.resource_name === "instance") {
									new_item.price[status] = parseFloat(event.target.value) ? 
									parseFloat(event.target.value) : 0
							} else {
									new_item.price = parseFloat(event.target.value) ? 
									parseFloat(event.target.value) : 0
							}
							return new_item
					} else {
							return item
					}
			})
			setSelectedResources(new_list)
	}

	const handleResourceAddReset = () => {
			setSelectedResources([])
			setResourceAddMode(false)
	}

	const handleSaveNewResources = async () => {
			if (selectedResources.length > 0) {
					let data = []
					for (let res in selectedResources) {
							if (selectedResources[res].resource_name === "instance") {
									let active_price = {
											...selectedResources[res], 
											price: selectedResources[res].price.active, 
											resource_status: "active"}
									let other_price = {
											...selectedResources[res], 
											price: selectedResources[res].price.other, 
											resource_status: "other"}
									data.push(active_price)
									data.push(other_price)
							} else {
									data.push({...selectedResources[res]})
							}
					}
					const url = `${constants.billing_url}/${billingServiceURLs.billingPricesEP}-list`
					let request_data = {
							url: url,
							method: "POST",
							data: {resources: data},
							headers: { 'customer-account-id': account_id },
					}
					const response = await request(request_data)
					if (response.status_code === 201) {
							setSelectedResources([])
							setResourceAddMode(false)
							handleDataFetch()
					}
			} else {
					setResourceAddMode(false)
			}
	}

	const handleSelectNewDefaultResourceEditing = (event, index) => {
		if (event.target.checked) {
			const new_list = [...new Set([...selectedDefaultResources, index])]
			setSelectedDefaultResources(new_list)
		} else {
			const new_list = selectedDefaultResources.filter(item => item !== index)
			setSelectedDefaultResources(new_list)
		}
	}

	const handleSelectNewFWResourceEditing = (event, index) => {
		if (event.target.checked) {
			const new_list = [...new Set([...selectedFWResources, index])]
			setSelectedFWResources(new_list)
		} else {
			const new_list = selectedFWResources.filter(item => item !== index)
			setSelectedFWResources(new_list)
		}
	}

	const handleSelectNewVPNResourceEditing = (event, index) => {
		if (event.target.checked) {
			const new_list = [...new Set([...selectedVPNResources, index])]
			setSelectedVPNResources(new_list)
		} else {
			const new_list = selectedVPNResources.filter(item => item !== index)
			setSelectedVPNResources(new_list)
		}
	}

	const handleFWCountChange = (event, index, position) => {
			let new_list = [...newFWResources]
			if (position === "start") {
					new_list[index].resource_count[0] = parseInt(event.target.value) ? parseInt(event.target.value) : 5
			} else {
					new_list[index].resource_count[1] = parseInt(event.target.value) ? parseInt(event.target.value) : 100000
			}
			setNewFWResources(new_list)
	}

	const handleDefaultRegionChange = (value, field_key, index) => {
		let new_list = [...newDefaultResources]
		new_list[index].region_name = value
		setNewDefaultResources(new_list)
	}

	const handleFWRegionChange = (value, field_key, index) => {
		let new_list = [...newFWResources]
		new_list[index].region_name = value
		setNewFWResources(new_list)
	}

	const handleVPNRegionChange = (value, field_key, index) => {
		let new_list = [...newVPNResources]
		new_list[index].region_name = value
		setNewVPNResources(new_list)
	}

	const handleVPNAlgorithmChange = (value, field_key, index) => {
		let new_list = [...newVPNResources]
		new_list[index].resource_id = value
		setNewVPNResources(new_list)
	}

	const handleDefaultPriceChange = (event, index) => {
		let new_list = [...newDefaultResources]
		new_list[index].price = parseFloat(event.target.value) ? 
		parseFloat(event.target.value) : 0
		setNewDefaultResources(new_list)
	}

	const handleFWPriceChange = (event, index) => {
		let new_list = [...newFWResources]
		new_list[index].price = parseFloat(event.target.value) ? 
		parseFloat(event.target.value) : 0
		setNewFWResources(new_list)
	}

	const handleVPNPriceChange = (event, index) => {
		let new_list = [...newVPNResources]
		new_list[index].price = parseFloat(event.target.value) ? 
		parseFloat(event.target.value) : 0
		setNewVPNResources(new_list)
	}

	const handleSaveNewDefaultResources = async () => {
		if (selectedDefaultResources.length > 0) {
			let data = newDefaultResources.filter((item, index) => selectedDefaultResources.includes(index))
			
			const url = `${constants.billing_url}/${billingServiceURLs.billingPricesEP}-list`

			let request_data = {
				url: url,
				method: "POST",
				data: {resources: data},
				headers: { 'customer-account-id': account_id },
			}
			
			const response = await request(request_data)

			if (response.status_code === 201) {
				setSelectedDefaultResources([])
				setNewDefaultResources([])
				handleDataFetch()
			}
		}
	}

	const handleSaveNewFWResources = async () => {
		if (selectedFWResources.length > 0) {
			let data = newFWResources.filter((item, index) => selectedFWResources.includes(index))
			
			const url = `${constants.billing_url}/${billingServiceURLs.billingPricesEP}-list`

			let request_data = {
				url: url,
				method: "POST",
				data: {resources: data},
				headers: { 'customer-account-id': account_id },
			}
			
			const response = await request(request_data)

			if (response.status_code === 201) {
				setSelectedFWResources([])
				setNewFWResources([])
				handleDataFetch()
			}
		}
	}

	const handleSaveNewVPNResources = async () => {
		if (selectedVPNResources.length > 0) {
			let data = newVPNResources.filter((item, index) => selectedVPNResources.includes(index))
			
			const url = `${constants.billing_url}/${billingServiceURLs.billingPricesEP}-list`

			let request_data = {
				url: url,
				method: "POST",
				data: {resources: data},
				headers: { 'customer-account-id': account_id },
			}
			
			const response = await request(request_data)

			if (response.status_code === 201) {
				setSelectedFWResources([])
				setNewFWResources([])
				handleDataFetch()
			}
		}
	}

	const resourceExisted = (resource_name) => {
		const resource = newDefaultResources.find(item => item.resource_name === resource_name)
		return resource ? true : false
	}

	const onNewResourceCreate = () => {
		let default_list = [...newDefaultResources]
		let vpn_list = [...newVPNResources]

		if (newFWResource) {
			let new_item = {}
			new_item["account_id"] = clientID
			new_item["resource_count"] = [5, 100]
			new_item["price"] = 0
			new_item["region_name"] = regions.length > 0 ? regions[0].value : ''
			new_item["resource_id"] = null
			new_item["resource_name"] = "fwaas_rule"
			new_item["service_name"] = openStackServices.networkService

			const new_list = [...newFWResources, new_item]
			setNewFWResources(new_list)
		}

		if (newIKEResource) {
			let new_item = {}
			new_item["account_id"] = clientID
			new_item["price"] = 0
			new_item["region_name"] = regions.length > 0 ? regions[0].value : ''
			new_item["resource_id"] = null
			new_item["resource_name"] = "vpn_ike"
			new_item["service_name"] = openStackServices.networkService

			vpn_list = [...vpn_list, new_item]
		}

		if (newIPSecResource) {
			let new_item = {}
			new_item["account_id"] = clientID
			new_item["price"] = 0
			new_item["region_name"] = regions.length > 0 ? regions[0].value : ''
			new_item["resource_id"] = null
			new_item["resource_name"] = "vpn_ipsec"
			new_item["service_name"] = openStackServices.networkService

			vpn_list = [...vpn_list, new_item]
		}

		if (newSnapshotResource && !resourceExisted('snapshot')) {
			const filtered_regions = getFilteredRegionList('snapshot')
			let new_item = {}
			new_item["account_id"] = clientID
			new_item["price"] = 0
			new_item["region_name"] = filtered_regions.length > 0 ? filtered_regions[0].value : ''
			new_item["resource_id"] = null
			new_item["resource_name"] = "snapshot"
			new_item["service_name"] = openStackServices.volumeService

			default_list = [...default_list, new_item]
		}

		if (newBackupResource && !resourceExisted('backup')) {
			const filtered_regions = getFilteredRegionList('backup')
			let new_item = {}
			new_item["account_id"] = clientID
			new_item["price"] = 0
			new_item["region_name"] = filtered_regions.length > 0 ? filtered_regions[0].value : ''
			new_item["resource_id"] = null
			new_item["resource_name"] = "backup"
			new_item["service_name"] = openStackServices.volumeService

			default_list = [...default_list, new_item]
		}

		if (newRouterResource && !resourceExisted('router')) {
			const filtered_regions = getFilteredRegionList('router')
			let new_item = {}
			new_item["account_id"] = clientID
			new_item["price"] = 0
			new_item["region_name"] = filtered_regions.length > 0 ? filtered_regions[0].value : ''
			new_item["resource_id"] = null
			new_item["resource_name"] = "router"
			new_item["service_name"] = openStackServices.networkService

			default_list = [...default_list, new_item]
		}

		if (newIPResource && !resourceExisted('floating_ip')) {
			const filtered_regions = getFilteredRegionList('floating_ip')
			let new_item = {}
			new_item["account_id"] = clientID
			new_item["price"] = 0
			new_item["region_name"] = filtered_regions.length > 0 ? filtered_regions[0].value : ''
			new_item["resource_id"] = null
			new_item["resource_name"] = "floating_ip"
			new_item["service_name"] = openStackServices.networkService

			default_list = [...default_list, new_item]
		}

		if (newImageResource && !resourceExisted('image')) {
			const filtered_regions = getFilteredRegionList('image')
			let new_item = {}
			new_item["account_id"] = clientID
			new_item["price"] = 0
			new_item["region_name"] = filtered_regions.length > 0 ? filtered_regions[0].value : ''
			new_item["resource_id"] = null
			new_item["resource_name"] = "image"
			new_item["service_name"] = openStackServices.imageService

			default_list = [...default_list, new_item]
		}

		if (newZoneResource && !resourceExisted('zone')) {
			const filtered_regions = getFilteredRegionList('zone')
			let new_item = {}
			new_item["account_id"] = clientID
			new_item["price"] = 0
			new_item["region_name"] = filtered_regions.length > 0 ? filtered_regions[0].value : ''
			new_item["resource_id"] = null
			new_item["resource_name"] = "zone"
			new_item["service_name"] = openStackServices.dnsService

			default_list = [...default_list, new_item]
		}

		if (newLoadbalancerResource && !resourceExisted('loadbalancer')) {
			const filtered_regions = getFilteredRegionList('loadbalancer')
			let new_item = {}
			new_item["account_id"] = clientID
			new_item["price"] = 0
			new_item["region_name"] = filtered_regions.length > 0 ? filtered_regions[0].value : ''
			new_item["resource_id"] = null
			new_item["resource_name"] = "loadbalancer"
			new_item["service_name"] = openStackServices.loadbalancerService

			default_list = [...default_list, new_item]
		}

		setNewDefaultResources(default_list)
		setNewVPNResources(vpn_list)
	}

	const handleImaNewResourceCreateDialogClose = () => {
			setNewResourceCreateDialogOpen(false)
	}

	useEffect(() => {
			if (!billingServicesChecked && billingServices.length > 0) {
					setBillingServicesChecked(true)
			}
	},[
			billingServices,
			billingServicesChecked
	])

	useEffect(() => {
		let result = false

		const filtered_resources = newFWResources.filter((item, index) => selectedFWResources.includes(index))

		filtered_resources.forEach(item => {
			const find_same = filtered_resources.filter(item2 => item.region_name === item2.region_name && item.resource_count[0] === item2.resource_count[0] && item.resource_count[1] === item2.resource_count[1])

			if (find_same.length > 1) {
				result = true
			}
		})

		setDuplicatedFWResources(result)
	}, [selectedFWResources, newFWResources])

	useEffect(() => {
		let result = false

		const filtered_resources = newVPNResources.filter((item, index) => selectedVPNResources.includes(index))

		filtered_resources.forEach(item => {
			const find_same = filtered_resources.filter(item2 => item.region_name === item2.region_name && item.resource_name === item2.resource_name && item.resource_id === item2.resource_id)

			if (find_same.length > 1) {
				result = true
			}
		})

		setDuplicatedVPNResources(result)
	}, [selectedVPNResources, newVPNResources])

	return (
			<React.Fragment>
					<Box sx={{height: 40, mt: 5}}>
							{ 
									<Grid 
											container 
											alignItems="center" 
											justifyContent="space-between"
									>
											<Grid item>
											{
												editPermission &&
												<Button 
													variant="contained" 
													color="secondary"
													onClick={() => setNewResourceCreateDialogOpen(true)}
												>
													{defaultTexts.addNewResourceButtonTitle}
												</Button>
											}											
											</Grid>
											<Grid item>
													<Grid 
															container
															alignItems="center" 
															justifyContent="flex-end"
													>
															{
																(editPermission && resourceAddMode) &&
																<Grid item>
																	<Tooltip title={defaultTexts.resetPriceEditModeTooltipText}>
																			<IconButton onClick={handleResourceAddReset} sx={{mr: 1}}>
																					<RxReset 
																							color={theme.palette.text.primary}
																							fontSize={'large'}
																					/>
																			</IconButton>
																	</Tooltip>
																</Grid>
															}

															<Grid item>
																	{
																		(editPermission && resourceAddMode) && 
																			<Button 
																					variant="contained" 
																					color="primary"
																					sx={{width: 120}}
																					onClick={handleSaveNewResources}
																			>
																					{defaultTexts.saveButtonTitle}
																			</Button>
																	}
																	{
																		(editPermission && !resourceAddMode) && 
																			<Button 
																					variant="outlined" 
																					color="primary"
																					sx={{width: 120}}
																					onClick={() => setResourceAddMode(true)}
																			>
																					{defaultTexts.editButtonTitle}
																			</Button>
																	}
															</Grid>
													</Grid>
											</Grid>
							</Grid>}
					</Box>
					{!resourceAddMode && <Box sx={{
							mt: 2
					}}>
							<TableContainer component={Paper}>
									<Table sx={{ minWidth: 300}} size="small">
											<TableHead>
													<TableRow>
															<TableCell  align="left">
																	{defaultTexts.serviceFormFieldLabel}
															</TableCell>
															<TableCell  align="left">
																	{defaultTexts.regionFormFieldLabel}
															</TableCell>
															<TableCell  align="left">
																	{defaultTexts.resourceFormFieldLabel}
															</TableCell>
															<TableCell  align="left">
																	{defaultTexts.nameFormFieldLabel}
															</TableCell>
													</TableRow>
											</TableHead>
											<TableBody>
													{newResources.map((row) => (
															<TableRow 
																	key={`${row.service_name}_${row.region_name}_${row.resource_name}_${row.id}`}
															>
																	<TableCell>{openStackServiceLabels[row.service_name]}</TableCell>
																	<TableCell>{row.region_name}</TableCell>
																	<TableCell>{openStackResourceLabels[row.resource_name]}</TableCell>
																	<TableCell>{row.name}</TableCell>
															</TableRow>
													))}
											</TableBody>
									</Table>
							</TableContainer>
					</Box>}
					{resourceAddMode && <Box sx={{
							mt: 2
					}}>
							<TableContainer component={Paper}>
									<Table sx={{ minWidth: 300}} size="small">
											<TableHead>
													<TableRow>
															<TableCell align="left" style={{width: 30}}/>
															<TableCell  align="left">
																	{defaultTexts.serviceFormFieldLabel}
															</TableCell>
															<TableCell  align="left">
																	{defaultTexts.regionFormFieldLabel}
															</TableCell>
															<TableCell  align="left">
																	{defaultTexts.resourceFormFieldLabel}
															</TableCell>
															<TableCell  align="left">
																	{defaultTexts.nameFormFieldLabel}
															</TableCell>
															<TableCell  align="right">
																	{defaultTexts.priceFormFieldLabel}
															</TableCell>
													</TableRow>
											</TableHead>
											<TableBody>
													{newResources.map((row) => (
															<TableRow key={`${row.service_name}_${row.region_name}_${row.id}`}>
																	<TableCell padding="checkbox">
																			<Checkbox
																					color="primary"
																					checked={selectedResources.filter(
																							price => price.resource_id === row.id).length > 0}
																					onClick={
																							(event) => handleSelectNewResourceEditing(event, row)
																					}
																			/>
																	</TableCell>
																	<TableCell>{openStackServiceLabels[row.service_name]}</TableCell>
																	<TableCell>{row.region_name}</TableCell>
																	<TableCell>{openStackResourceLabels[row.resource_name]}</TableCell>
																	<TableCell>{row.name}</TableCell>
																	{selectedResources.filter(price => price.resource_id === row.id).length > 0 ?
																			<React.Fragment>
																			{row.resource_name === "instance" ? 
																					<TableCell align="right">
																							<TextField 
																									variant="standard" 
																									label={defaultTexts.activeStatusFormFieldLabel}
																									value={selectedResources.filter(
																											i => i.resource_id === row.id)[0].price.active}
																									onChange={(event) => handlePriceChange(event, row.id, "active")}
																									color="primary"
																									type="number"
																									inputProps={{
																											step: 0.000001
																									}}
																									sx={{width: 100}}
																							/>
																							<TextField 
																									variant="standard" 
																									label={defaultTexts.otherStatusFormFieldLabel}
																									value={selectedResources.filter(i => i.resource_id === row.id)[0].price.other}
																									onChange={(event) => handlePriceChange(event, row.id, "other")}
																									color="primary"
																									type="number"
																									inputProps={{
																											step: 0.000001
																									}}
																									sx={{width: 100}}
																							/>
																					</TableCell> :
																					<TableCell  align="right">
																							<TextField 
																									variant="standard" 
																									value={selectedResources.filter(i => i.resource_id === row.id)[0].price}
																									onChange={(event) => handlePriceChange(event, row.id)}
																									color="primary"
																									type="number"
																									inputProps={{
																											step: 0.000001
																									}}
																									sx={{width: 200}}
																							/>
																					</TableCell>
																			}
																			</React.Fragment> :
																			<TableCell align="right">{defaultTexts.noPriceTableTitle}</TableCell>
																	}
															</TableRow> 
													))}
											</TableBody>
									</Table>
							</TableContainer>
					</Box>
					}

					












					{
						newDefaultResources.length > 0 && <Box sx={{
							mt: 2
						}}>
							<Button 
									variant="contained" 
									color="primary"
									sx={{width: 120, my: 2}}
									onClick={handleSaveNewDefaultResources}
							>
									{defaultTexts.saveButtonTitle}
							</Button>
							<TableContainer component={Paper}>
									<Table sx={{ minWidth: 300}} size="small">
											<TableHead>
													<TableRow>
															<TableCell align="left" style={{width: 30}}/>
															<TableCell  align="left">
																	{defaultTexts.serviceFormFieldLabel}
															</TableCell>
															<TableCell  align="left">
																	{defaultTexts.regionFormFieldLabel}
															</TableCell>
															<TableCell  align="left">
																	{defaultTexts.resourceFormFieldLabel}
															</TableCell>
															<TableCell  align="right">
																	{defaultTexts.priceFormFieldLabel}
															</TableCell>
													</TableRow>
											</TableHead>
											<TableBody>
													{
														newDefaultResources.map((row,index) => (
															<TableRow key={index}>
																	<TableCell padding="checkbox">
																			<Checkbox
																					color="primary"
																					checked={selectedDefaultResources.includes(index)}
																					onClick={
																							(event) => handleSelectNewDefaultResourceEditing(event, index)
																					}
																			/>
																	</TableCell>
																	<TableCell>{openStackServiceLabels[row.service_name]}</TableCell>
																	<TableCell>
																		<CustomSelectField
																			variant="standard" 
																			items={getFilteredRegionList(row.resource_name)} 
																			currentValue={row.region_name}
																			setCurrentValue={handleDefaultRegionChange}
																			index={index}
																			self_item_titles={true}
																			size='small'
																			sx={{ width: 160 }}
																		/>
																	</TableCell>
																	<TableCell>{openStackResourceLabels[row.resource_name]}</TableCell>
																	<TableCell  align="right">
																			<TextField 
																					variant="standard" 
																					value={row.price}
																					onChange={(event) => handleDefaultPriceChange(event, index)}
																					color="primary"
																					type="number"
																					inputProps={{
																							step: 0.000001
																					}}
																					sx={{width: 200}}
																			/>
																	</TableCell>
															</TableRow> 
													))}
											</TableBody>
									</Table>
							</TableContainer>
						</Box>
					}



					{
						newFWResources.length > 0 && <Box sx={{
							mt: 2
						}}>
							<Button 
									variant="contained" 
									color="primary"
									disabled={duplicatedFWResources}
									sx={{width: 120, my: 2}}
									onClick={handleSaveNewFWResources}
							>
									{defaultTexts.saveButtonTitle}
							</Button>
							<TableContainer component={Paper}>
									<Table sx={{ minWidth: 300}} size="small">
											<TableHead>
													<TableRow>
															<TableCell align="left" style={{width: 30}}/>
															<TableCell  align="left">
																	{defaultTexts.serviceFormFieldLabel}
															</TableCell>
															<TableCell  align="left">
																	{defaultTexts.regionFormFieldLabel}
															</TableCell>
															<TableCell  align="left">
																	{defaultTexts.resourceFormFieldLabel}
															</TableCell>
															<TableCell  align="left">
																	{defaultTexts.ruleRangeStartFormFieldLabel}
															</TableCell>
															<TableCell  align="left">
																	{defaultTexts.ruleRangeEndFormFieldLabel}
															</TableCell>
															<TableCell  align="right">
																	{defaultTexts.priceFormFieldLabel}
															</TableCell>
													</TableRow>
											</TableHead>
											<TableBody>
													{newFWResources.map((row,index) => (
															<TableRow key={index}>
																	<TableCell padding="checkbox">
																			<Checkbox
																					color="primary"
																					checked={selectedFWResources.includes(index)}
																					onClick={
																							(event) => handleSelectNewFWResourceEditing(event, index)
																					}
																			/>
																	</TableCell>
																	<TableCell>{openStackServiceLabels[row.service_name]}</TableCell>
																	<TableCell>
																		<CustomSelectField
																			variant="standard" 
																			items={regions} 
																			currentValue={row.region_name}
																			setCurrentValue={handleFWRegionChange}
																			index={index}
																			self_item_titles={true}
																			size='small'
																			sx={{width: 160}}
																		/>
																	</TableCell>
																	<TableCell>{openStackResourceLabels[row.resource_name]}</TableCell>
																	<TableCell  align="left">
																			<TextField 
																					variant="standard" 
																					value={row.resource_count[0]}
																					onChange={(event) => handleFWCountChange(event, index, "start")}
																					color="primary"
																					type="number"
																					sx={{width: 160}}
																			/>
																	</TableCell>
																	<TableCell  align="left">
																			<TextField 
																					variant="standard" 
																					value={row.resource_count[1]}
																					onChange={(event) => handleFWCountChange(event, index, "end")}
																					color="primary"
																					type="number"
																					sx={{width: 160}}
																			/>
																	</TableCell>
																	<TableCell  align="right">
																			<TextField 
																					variant="standard" 
																					value={row.price}
																					onChange={(event) => handleFWPriceChange(event, index)}
																					color="primary"
																					type="number"
																					inputProps={{
																							step: 0.000001
																					}}
																					sx={{width: 200}}
																			/>
																	</TableCell>
															</TableRow> 
													))}
											</TableBody>
									</Table>
							</TableContainer>
						</Box>
					}


					{
						newVPNResources.length > 0 && <Box sx={{
							mt: 2
						}}>
							<Button 
									variant="contained" 
									color="primary"
									disabled={duplicatedVPNResources}
									sx={{width: 120, my: 2}}
									onClick={handleSaveNewVPNResources}
							>
									{defaultTexts.saveButtonTitle}
							</Button>
							<TableContainer component={Paper}>
									<Table sx={{ minWidth: 300}} size="small">
											<TableHead>
													<TableRow>
															<TableCell align="left" style={{width: 30}}/>
															<TableCell  align="left">
																	{defaultTexts.serviceFormFieldLabel}
															</TableCell>
															<TableCell  align="left">
																	{defaultTexts.regionFormFieldLabel}
															</TableCell>
															<TableCell  align="left">
																	{defaultTexts.resourceFormFieldLabel}
															</TableCell>
															<TableCell  align="left">
																	{defaultTexts.encryptionAlgorithmFormFieldLabel}
															</TableCell>
															<TableCell  align="right">
																	{defaultTexts.priceFormFieldLabel}
															</TableCell>
													</TableRow>
											</TableHead>
											<TableBody>
													{newVPNResources.map((row,index) => (
															<TableRow key={index}>
																	<TableCell padding="checkbox">
																			<Checkbox
																					color="primary"
																					checked={selectedVPNResources.includes(index)}
																					onClick={
																							(event) => handleSelectNewVPNResourceEditing(event, index)
																					}
																			/>
																	</TableCell>
																	<TableCell>{openStackServiceLabels[row.service_name]}</TableCell>
																	<TableCell>
																		<CustomSelectField
																			variant="standard" 
																			items={regions} 
																			currentValue={row.region_name}
																			setCurrentValue={handleVPNRegionChange}
																			index={index}
																			self_item_titles={true}
																			size='small'
																			sx={{width: 160}}
																		/>
																	</TableCell>
																	<TableCell>{openStackResourceLabels[row.resource_name]}</TableCell>
																	<TableCell  align="left">
																		<CustomSelectField
																			variant="standard" 
																			items={algorithm_list} 
																			currentValue={row.resource_id}
																			setCurrentValue={handleVPNAlgorithmChange}
																			index={index}
																			self_item_titles={true}
																			size='small'
																			sx={{width: 160}}
																		/>
																	</TableCell>
																	<TableCell  align="right">
																			<TextField 
																					variant="standard" 
																					value={row.price}
																					onChange={(event) => handleVPNPriceChange(event, index)}
																					color="primary"
																					type="number"
																					inputProps={{
																							step: 0.000001
																					}}
																					sx={{width: 200}}
																			/>
																	</TableCell>
															</TableRow> 
													))}
											</TableBody>
									</Table>
							</TableContainer>
						</Box>
					}







					<CustomDialog
							open={newResourceCreateDialogOpen}
							onClose={handleImaNewResourceCreateDialogClose}
							dialogTitle={{
									title: defaultTexts.selectNewResourceToCreateFormTitle, 
									sx: {color: 'primary.main'}}}
							dialogBody={{
									text: defaultTexts.selectNewResourceToCreateFormText, 
									sx: {color: 'text.primary'}}}
							actionButtons={[{
									title: defaultTexts.submitButtonText,
									onClick: onNewResourceCreate, 
									sx: {color: 'primary.main'}}]}
					>
						{
							!isResourcePriceSet('snapshot') &&
							<Box>
								<FormControlLabel 
									control={
										<Checkbox 
											color="primary"
											checked={newSnapshotResource}
											onClick={(event) => setNewSnapshotResource(!newSnapshotResource)}
											/>
										} 
									label={defaultTexts.snapshotFormFieldLabel}
								/>
							</Box>
						}

						{
							!isResourcePriceSet('backup') &&
							<Box>
								<FormControlLabel 
									control={
										<Checkbox 
											color="primary"
											checked={newBackupResource}
											onClick={(event) => setNewBackupResource(!newBackupResource)}
											/>
										} 
									label={defaultTexts.backupVolSourceChoiceTitle}
								/>
							</Box>
						}	

						{
							!isResourcePriceSet('router') &&
							<Box>
								<FormControlLabel 
									control={
										<Checkbox 
											color="primary"
											checked={newRouterResource}
											onClick={(event) => setNewRouterResource(!newRouterResource)}
											/>
										} 
									label={defaultTexts.routerFormFieldLabel}
								/>
							</Box>
						}

						{
							!isResourcePriceSet('floating_ip') &&
							<Box>
								<FormControlLabel 
									control={
										<Checkbox 
											color="primary"
											checked={newIPResource}
											onClick={(event) => setNewIPResource(!newIPResource)}
											/>
										} 
									label={defaultTexts.floatingIPFormFieldLabel}
								/>
							</Box>
						}						

						<Box>
							<FormControlLabel 
								control={
									<Checkbox 
										color="primary"
										checked={newFWResource}
										onClick={(event) => setNewFWResource(!newFWResource)}
										/>
									} 
								label={defaultTexts.firewallRuleRangeFormFieldLable}
							/>
						</Box>

						<Box>
							<FormControlLabel 
								control={
									<Checkbox 
										color="primary"
										checked={newIKEResource}
										onClick={(event) => setNewIKEResource(!newIKEResource)}
										/>
									} 
								label={defaultTexts.ikePolicyFormFieldLabel}
							/>
						</Box>

						<Box>
							<FormControlLabel 
								control={
									<Checkbox 
										color="primary"
										checked={newIPSecResource}
										onClick={(event) => setNewIPSecResource(!newIPSecResource)}
										/>
									} 
								label={defaultTexts.ipsecPolicyFormFieldLabel}
							/>
						</Box>
						
						{
							!isResourcePriceSet('image') &&
							<Box>
								<FormControlLabel 
									control={
										<Checkbox 
											color="primary"
											checked={newImageResource}
											onClick={(event) => setNewImageResource(!newImageResource)}
											/>
										} 
									label={defaultTexts.imageFormFieldLabel}
								/>
							</Box>
						}

						{
							!isResourcePriceSet('zone') &&
							<Box>
								<FormControlLabel 
									control={
										<Checkbox 
											color="primary"
											checked={newZoneResource}
											onClick={(event) => setNewZoneResource(!newZoneResource)}
											/>
										} 
									label={defaultTexts.zoneFormFieldLabel}
								/>
							</Box>
						}

						{
							!isResourcePriceSet('loadbalancer') &&
							<Box>
								<FormControlLabel 
									control={
										<Checkbox 
											color="primary"
											checked={newLoadbalancerResource}
											onClick={(event) => setNewLoadbalancerResource(!newLoadbalancerResource)}
											/>
										} 
									label={defaultTexts.loadbalancerFormFieldLabel}
								/>
							</Box>
						}		
					</CustomDialog>
			</React.Fragment>
	)
}

export default BillingNewResources